module.exports = __webpack_public_path__ + "img/tax-reform-webinar-topic-button.38fdb8ba.webp";